import { Injectable } from '@angular/core';
import { PagedResult, Problem } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class ProblemsApi {
  constructor(private apollo: Apollo) { }

  searchProblems({
    where = {},
    limit = 10,
    offset = 0,
    orderBy = {
      column: 'name',
      direction: 'desc'
    }
  }): Promise<Problem[]> {
    return this.apollo.query<PagedResult>({
      query: gql`
        query searchProblems($where: ProblemWhereInput, $limit: Int, $offset: Int, $orderBy: ProblemOrderByInput) {
          problems(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
            items {
              id
              name
            }
          }
        }
      `,
      variables: {
        where,
        limit,
        offset,
        orderBy
      }
    }).toPromise()
      .then((result) => result['data']['problems']['items']);
  }
}
